import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { I18n, CustomDatepickerI18nService } from 'src/app/modules/core/services/custom-datepicker-i18n.service';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbDate, NgbDatepickerConfig, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerFormaterService } from 'src/app/modules/core/services/custom-datepicker-formater.service';
import { dateToNgb } from '../../services/datetime.service';
import * as moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService },
    { provide: NgbDateParserFormatter, useClass: CustomDatepickerFormaterService }
  ]
})
export class DatepickerComponent implements OnInit, OnChanges {

  @Input() public startSelectedDate: NgbDateStruct;
  @Input() public maxDate: NgbDateStruct;
  @Input() public minDate: NgbDateStruct;

  @Output() public selectedDateEvent = new EventEmitter<NgbDate>();

  @ViewChild('datepickerContainer', { static: false })
  public datePickerView: ElementRef;

  @ViewChild('dp', { static: false })
  public datepicker: NgbDatepicker;

  public selectedDate: NgbDate;
  public displayedDate: string;
  private startDate: { year: number, month: number, day?: number };

  /**
   * Detect document click, used to close popup when the user click outside of the dp
   * @param targetElement element clicked
   */
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement): void {
    if (!targetElement.className.includes('dp')) {
      const style = this.datePickerView.nativeElement.style;
      style.display = 'none';
    }
  }

  constructor(
    private ngbdatepickerConfig: NgbDatepickerConfig,
  ) {
    this.ngbdatepickerConfig.navigation = 'arrows';
  }

  ngOnInit() {

    // set the started date of the datepicker
    if (this.startSelectedDate) {
      this.selectedDate = this.startSelectedDate as NgbDate;
    } else {
      this.selectedDate = dateToNgb(new Date());
    }

    if (this.maxDate) {
      this.maxDate = this.maxDate;
    } else {
      this.maxDate = dateToNgb(new Date());
    }

    if (this.minDate) {
      this.minDate = this.minDate;
    }

    this.setDisplayedDate(this.selectedDate);
  }

  public ngOnChanges(changes: SimpleChanges): void {

    if (changes['minDate'] && changes['minDate'].currentValue) {
      this.minDate = changes['minDate'].currentValue;
    }

    if(changes['startSelectedDate'] && changes['startSelectedDate'].currentValue){
      if(this.datepicker){
        this.selectedDate = changes['startSelectedDate'].currentValue as NgbDate;
        this.datepicker.navigateTo(this.selectedDate);
        this.setDisplayedDate(this.selectedDate);
        this.selectedDateEvent.emit(this.selectedDate);

      }
    }

  }

  /**
   * Format the date selected from datepicker and display in the input
   * @param date date selected from datepicker
   */
  private setDisplayedDate(date: NgbDate): void {
    this.displayedDate = `${date.day < 10 ? '0' + date.day : date.day}/`;
    this.displayedDate += `${date.month < 10 ? '0' + date.month : date.month}/${date.year}`;
  }

  /**
   * Function to open or close calendar
   */
  public toggleCalendar(force?: boolean): void {
    const style = this.datePickerView.nativeElement.style;
    if (style.display === 'block' || force) {
      style.display = 'none';
    } else {
      style.display = 'block';
    }
    this.datepicker.navigateTo(this.selectedDate);
  }

  /**
   * Event that is fired when a date is selected
   * @param value date selected
   */
  public onDateSelected(value: NgbDate): void {
    this.selectedDate = value;
    this.setDisplayedDate(this.selectedDate);
    this.toggleCalendar();
    this.selectedDateEvent.emit(value);
  }

  /**
   * Expose the selected date to the parent Component
   */
  public getSelectedDate(): NgbDate {
    return this.selectedDate;
  }

}
